import { useTranslations } from '@vocab/react';
import { Dialog, Text, Box, Button, Stack } from 'braid-design-system';

import {
  ANALYTICS_LOGIN_MESSAGE,
  ANALYTICS_LOGIN_LINK_TEXT,
} from 'src/core/domain/constants';
import { useAnalytics } from 'src/provider/analytics';
import { useAuthStatus } from 'src/provider/auth';
import { useLoginModal } from 'src/provider/loginModal';

import translations from './.vocab';

import * as styles from './LoginModal.css';

export default () => {
  const { t } = useTranslations(translations);
  const {
    state: { showLoginDialog },
    closeLoginDialog,
  } = useLoginModal();
  const { login } = useAuthStatus();
  const { trackAnalyticsInteraction } = useAnalytics();
  const handleOnClick = async () => {
    trackAnalyticsInteraction('SignInClick', {
      message: ANALYTICS_LOGIN_MESSAGE,
      linkText: ANALYTICS_LOGIN_LINK_TEXT,
    });
    login();
    closeLoginDialog();
  };

  return (
    <Stack space="gutter">
      <Dialog
        id="login"
        title=""
        illustration={
          <Box style={{ height: 128, width: 128 }} className={styles.Icon} />
        }
        open={showLoginDialog}
        onClose={closeLoginDialog}
        width="xsmall"
        data={{ testid: 'login-modal' }}
      >
        <Text tone="neutral" size="large" weight="strong" align="center">
          {t('signInOrRegisterToJoin')}
          <br />
          {t('theConversation')}{' '}
        </Text>

        <Text id="text-prettier" tone="neutral" size="standard" align="center">
          {t('youNeedToSignInToEngageWithThreads')}
        </Text>
        <Box style={{ textDecoration: 'none' }}>
          <Button tone="formAccent" variant="solid" onClick={handleOnClick}>
            {t('signInOrRegister')}
          </Button>
        </Box>
      </Dialog>
    </Stack>
  );
};
